import { post } from '@/utils/request'
import dayjs from 'dayjs'

const TYPE = {
  '日': 1,
  '周': 2,
  '月': 3,
  'day': 1,
  'week': 2,
  'month': 3,
  1: 1,
  2: 2,
  3: 3,
}


const fmtDate = {
  1: (dayModel) => {
    let [day, day_end] = dayModel
    return {
      day: dayjs(day).format('YYYY-MM-DD'),
      day_end: dayjs(day_end).format('YYYY-MM-DD'),
    }
  },
  2: (dayModel) => {
    // 周的最后一天
    dayModel = dayjs(dayModel)
    if (dayModel.day() === 0) {
      return { day: dayjs(dayModel).format('YYYY-MM-DD') }
    }
    return { day: dayModel.endOf('week').add(1, 'date').format('YYYY-MM-DD') }
  },
  3: (dayModel) => {
    // 月的周后一天
    return { day: dayjs(dayModel).endOf('month').format('YYYY-MM-DD') }
  },
}

/**
 *
 * @description admin首页统计
 * @param {String} show_type // 日期类型 1日 2周 3月
 * @param {Date,Array} dayModel // 日期或日期范围
 */
export default function admin_data_rpt(show_type, dayModel) {

  if (show_type) show_type = TYPE[show_type]
  if (dayModel && show_type) dayModel = fmtDate[show_type](dayModel)

  return post('admin_data_rpt', { show_type, ...dayModel })
}
